export default __webpack_public_path__ + "static/media/H60954.72c86287.jpg";